import {
  ScoreLevel as NotificationScoreLevel,
  type InfringementMatchMetadata,
} from '@/shared/graphql/legacy/generated'
import {
  FileType,
  InfringementLabel,
  ScoreLevel,
} from '@/shared/graphql/router/graphql'
import { createAsset } from '@/features/infringement/store'
import type { FlaggedInfringement } from './useFlaggedMatch'

const FILE_TYPES: Record<string, FileType> = Object.fromEntries(
  Object.values(FileType).map((type) => [type, type])
)

const toFileType = (type: string): FileType =>
  FILE_TYPES[type] ?? FileType.Generic

const SCORE_LEVELS: Record<NotificationScoreLevel, ScoreLevel> = {
  [NotificationScoreLevel.High]: ScoreLevel.High,
  [NotificationScoreLevel.Medium]: ScoreLevel.Medium,
  [NotificationScoreLevel.Low]: ScoreLevel.Low,
}

export const toFlaggedInfringement = (
  metadata: InfringementMatchMetadata,
  timestamp: FlaggedInfringement['timestamp']
): FlaggedInfringement => {
  const { infringingFile: registeredWork, registeredFile: flaggedWork } =
    metadata
  const registeredType = toFileType(registeredWork.type)
  const flaggedType = toFileType(flaggedWork.type)

  return {
    __typename: 'Infringement',
    id: metadata.id,
    label: InfringementLabel.Flag,
    timestamp,
    copyrights: [
      {
        __typename: 'File',
        id: registeredWork.id,
        name: registeredWork.vanityName,
        type: registeredType,
        asset: createAsset(registeredType, registeredWork.imageUrl),
        copyright: {
          __typename: 'FileCopyright',
          id: registeredWork.copyrightId,
        },
      },
    ],
    infringingFile: {
      __typename: 'InfringingFile',
      id: flaggedWork.id,
      name: flaggedWork.vanityName,
      copyrightId: flaggedWork.copyrightId,
      type: flaggedType,
      asset: createAsset(flaggedType, flaggedWork.imageUrl),
    },
    matches: {
      __typename: 'MatchSummary',
      score: 0,
      level: SCORE_LEVELS[metadata.level],
      breakdown: [],
    },
    report: null,
  }
}
